export default __webpack_public_path__ + "static/media/search-icon.90696903.svg";